import { render, staticRenderFns } from "./ClientByCategory.vue?vue&type=template&id=e245fef4"
import script from "./ClientByCategory.vue?vue&type=script&lang=js"
export * from "./ClientByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports